import {Container, Stack, VStack} from '@styled-system/jsx';
import {h1, h2, h3} from '@styled-system/recipes';

const RefundPolicyPage = () => {
  return <Container>
    <VStack p={8} alignItems="flex-start">
      <h1 className={h1()}>
        Refund / Return Policy
      </h1>
      <h2 className={h2()}>
        Refunds
      </h2>
      <p>
        All sales are final. All sales are in US Dollars. We apologize, but we are not able to give refunds. Once an
        order
        is placed, your contest entries are automatically and immediately submitted to our sweepstakes company. We
        cannot
        tamper with the entries for any promotion.
      </p>
      <h2 className={h2()}>
        Exchanges
      </h2>
      <p>
        We welcome all exchanges. Any item you would like to exchange for another style must be in new and unused
        condition. Customer is responsible for shipping products to Fanathem. We will resend the exchanged
        item
        to you for free. You can exchange merchandise for any item or items of equal value, or you may increase and pay
        the cost increase. We cannot approve any downgrade that would result in a refund. Contest entries cannot be
        altered or rescinded.
      </p>
      <p>
        All exchanges must be initiated within 30 days of purchase. Any issues with defective merchandise must also be
        reported within 30 days of the date of purchase for warranty replacement. After 30 days, we have no further
        liability.
      </p>
      <p>
        Please send all exchanges with a printout of the original invoice and copies of any correspondence you have had
        with Customer Service. Please specify the name of the product you would like in exchange, and what size you
        would
        like. Include a screenshot of your confirmation with your return package or email the confirmation with your
        order
        number to support@fanathem.com
      </p>
      <p>
        If you receive an item that is damaged or is incorrectly shipped by us please contact Customer Support
        immediately. You may do so at support@fanathem.com or by texting 973-577-5771
      </p>
      <p>
        Exchanges are discretionary upon inspection of item(s) when we receive your merchandise.
      </p>
      <p>
        Customer is responsible for all shipping costs.
      </p>
      <Stack
        py={4}
        px={6}
        bgColor="blue.100"
        borderRadius="lg"
        direction={{base: 'column', lg: 'row'}}
        alignItems="flex-start"
        gap={8}
      >
        <VStack alignItems="flex-start">
          <h3 className={h3()}>
            Shipping address for exchange
          </h3>
          <div>
            Fanathem<br/>
            C/O Remarkabl, Inc.<br/>
            55 Madison Ave Ste 400<br/>
            Morristown, NJ 07960
          </div>
        </VStack>
        <VStack alignItems="flex-start">
          <h3 className={h3()}>
            Contacting Us
          </h3>
          <div>
            support@fanathem.com
          </div>
          <div>
            973-577-5771
          </div>
        </VStack>
      </Stack>
    </VStack>
  </Container>
}

export default RefundPolicyPage;
